/* global React, Icon, PlummeI18n */
// ============================================================
// Privatøkonomi — hovedhero
// Bruker samme visuelle språk som AI Rådgiver, men alle tall
// kommer fra privatøkonomiens egen readmodel.
// ============================================================

const poHeroAvatar = () => (window.__resources && window.__resources.superPlummaHero) || 'src/img/SuperPlumma.png';
const poHeroGreeting = (name) => {
  const hour = new Date().getHours();
  const part = hour < 6 ? 'night' : hour < 11 ? 'morning' : hour < 18 ? 'day' : 'evening';
  return t(`po.hero.greeting${name ? 'Named' : ''}.${part}`, name ? { name } : undefined);
};

function PoAdvisorHero({ advice = '', onAsk, tab = 'idag', userName = '' }) {
  const dateLabel = PlummeI18n.date(new Date(), { weekday: 'long', day: 'numeric', month: 'long' });
  const firstName = String(userName).trim().split(/[\s@]+/)[0] || '';
  return <div className="aii-hero po-advisor-hero">
    <div className="aii-hero-grid">
      <div className="aii-hero-brief">
        <div className="aii-hero-tag"><Icon name="sparkle" size={16} />{t(`po.hero.section.${tab}`)} · {dateLabel}</div>
        <div className="aii-hero-lead">{poHeroGreeting(firstName)} <span aria-hidden="true">👋</span></div>
        <p className="po-advisor-hero-advice">{String(advice || '').trim() || t(`po.hero.advice.${tab}`)}</p>
        <div className="aii-hero-foot">
          <button type="button" className="aii-hero-pill aii-hero-pill-btn" onClick={onAsk}><Icon name="sparkle" size={15} />{t('adv.hero.ask')}</button>
        </div>
      </div>
      <div className="aii-hero-side">
        <button type="button" className="aii-plum-launch" onClick={onAsk} title={t('adv.hero.chatTitle')}>
          <img className="aii-hero-plum" src={poHeroAvatar()} alt="SuperPlumma" />
          <span className="aii-plum-hint"><Icon name="sparkle" size={13} />{t('adv.hero.chatHint')}</span>
        </button>
      </div>
    </div>
  </div>;
}

Object.assign(window, { PoAdvisorHero });
